import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICreateTenantRequest, ITenant, IUpdateTenantRequest } from './tenant';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  constructor(private http: HttpClient) { }

  listTenants(){
    return this.http.get<ITenant[]>(
      `${environment.baseUrl}/tenants`
    )
  }

  createTenant(request: ICreateTenantRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/tenants`,
      request,
      {responseType: 'text' as 'json'}
    )
  }

  activateTenant(tenantId: string){
    return this.http.post<string>(
      `${environment.baseUrl}/tenants/${tenantId}/activate`,
      null,
      {responseType: 'text' as 'json'}
    )
  }

  deactivateTenant(tenantId: string){
    return this.http.post<string>(
      `${environment.baseUrl}/tenants/${tenantId}/deactivate`,
      null,
      {responseType: 'text' as 'json'}
    )
  }

  upgradeTenant(request : {tenantId, extendedExpiryDate}){
    return this.http.post<string>(
      `${environment.baseUrl}/tenants/${request.tenantId}/upgrade`,
      request,
      {responseType: 'text' as 'json'}
    )
  }

  updateTenant(request : IUpdateTenantRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/tenants/${request.tenantId}/update`,
      request,
      {responseType: 'text' as 'json'}
    )
  }
}
